import reactTemplate from "./react-people-list.pug";
import { PageContentViewModel } from "@/lib/vm/page-content-viewmodel";
import type { Root } from "react-dom/client";
import renderReactComponent from "@/react/render-react-component";

export class PeopleList2ViewModel extends PageContentViewModel {
   private reactRoot: Root | null;

   constructor() {
      super(reactTemplate(), "List");

      this.reactRoot = null;
   }

   addedToParent(): void {
      this.reactRoot = renderReactComponent("react-people-list-mount", "PeopleListContainer", {
         setTitle: (title: string) => this.setTitle(title),
      });
   }

   removedFromParent(): void {
      if (this.reactRoot) {
         this.reactRoot.unmount();
      }
   }
}
